import ForgotPassContainer from "../components/pageComponents/Login/ForgotPassContainer";

const ForgotPass=()=>{
    return(
    <div><ForgotPassContainer /></div>);
}
export default ForgotPass;